import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
  Button,
  Textarea,
} from "@chakra-ui/react";
import { useCallback, useState } from "react";
import { useAPI } from "../api/useAPI";
import { useAPIQuery } from "../api/useAPIQuery";
import { useToastOnAPIError } from "../api/useToastOnAPIError";
import { DataCard } from "../utils/DataCard";
import { THEME_COLOR_SCHEME } from "../utils/theme";

export const DatabasePanel = () => {
  const [sql, setSql] = useState("");
  const api = useAPI();
  const { data, state, error, query } = useAPIQuery<"devSql">({
    apiCall: api.devSql,
  });
  useToastOnAPIError({ title: "Query error", error });

  const onRun = useCallback(() => {
    query({ sql });
  }, [query, sql]);

  return (
    <Box width={"100%"}>
      <Textarea
        size="lg"
        rows={10}
        value={sql}
        onChange={(e) => setSql(e.target.value)}
      />
      <Box
        width={"100%"}
        display={"flex"}
        justifyContent={"flex-end"}
        marginTop={4}
      >
        <Button
          isLoading={state === "loading"}
          colorScheme={THEME_COLOR_SCHEME}
          onClick={onRun}
        >
          Run
        </Button>
      </Box>
      {data ? (
        data.status === "success" ? (
          <Box display={"flex"} flexDir={"column"}>
            {data.result.length > 0 ? (
              data.result.map((data) => (
                <DataCard key={JSON.stringify(data)} data={data} />
              ))
            ) : (
              <Alert
                status="warning"
                marginTop={4}
                variant="subtle"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                textAlign="center"
              >
                <AlertIcon />
                <AlertTitle>Warning</AlertTitle>
                <AlertDescription>No rows returned</AlertDescription>
              </Alert>
            )}
          </Box>
        ) : data.status === "error" ? (
          <Alert
            status="error"
            marginTop={4}
            variant="subtle"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            textAlign="center"
          >
            <AlertIcon />
            <AlertTitle>Error</AlertTitle>
            <AlertDescription>{data.error}</AlertDescription>
          </Alert>
        ) : null
      ) : null}
    </Box>
  );
};
